var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Time table","border-variant":"info"}},[_c('b-card-text',[_c('p',[_vm._v("This card shows the current timeline for manual and auto mode. It displays only moments when the pump will be ON")]),_c('div',[_c('timeline',{ref:"timeline",attrs:{"items":_vm.items,"groups":_vm.groups,"options":_vm.options}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }